<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
    <form class="form-group flex column filter-form" [formGroup]="form" >
      <!-- date -->
      <div class="field flex column">
        <mat-label class="field-label">{{ "Filter.Form.Time" | translate }}</mat-label>
        <div class="dropdown-field">
          <app-date-range
          formControlName="dateRange"
          [showCustomDateOption]="true"
        ></app-date-range>
        </div>
      </div>


       <!-- From -->
       <div class="field flex column">
        <mat-label class="field-label">{{ "Filter.Form.From" | translate }}</mat-label>
        <div class="dropdown-field">
          <app-lazy-dropdown
          formControlName="from"
          [lookup]="cities"
        >
        </app-lazy-dropdown>
        </div>
      </div>

      <!-- To -->
      <div class="field flex column">
        <mat-label class="field-label">{{ "Filter.Form.To" | translate }}</mat-label>
        <div class="dropdown-field">
          <app-lazy-dropdown
            formControlName="to"
            [lookup]="cities"
          >
          </app-lazy-dropdown>
        </div>
      </div>

      <!-- waiting charge -->
      <div class="field flex column">
        <mat-label class="field-label">{{ "Filter.Form.WaitingCharge" | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            [placeholder]="
              'Placeholder.WriteTheValue' | translate
            "
            formControlName="waitingCharge"
          />
        </mat-form-field>
      </div>

      <!-- multiDis -->
      <div class="field flex column">
        <mat-label class="field-label">{{ "Filter.Form.MultiDistance" | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            [placeholder]="
                'Placeholder.WriteTheValue' | translate
              "
            formControlName="multiDis"
          />
        </mat-form-field>
      </div>


    </form>
  </app-state-section>
